<template>
  <van-popup
    class="system-update"
    :class="{ fill: opts.styleType == 1 }"
    getContainer="body"
    round
    v-model="opened"
    :close-on-click-overlay="false"
  >
    <template v-if="opts.styleType == 1">
      <img class="update-img" :src="opts.showImgUrl" @click="confirm"/>
      <div class="popup-close"><van-icon name="close" size="36" color="#FFF" @click="cancel('leftButton')" /></div>
    </template>
    <template v-else>
      <!-- 文字内容 -->
      <div
        class="popup-top"
        v-show="opts.type == 0"
        :class="{ sports: opts.productPackage == 3 }"
      ></div>
      <div class="popup-content" :class="{ mg: opts.type == 0 }">
        <template v-if="opts.type == 0">
          <div
            class="is-txt"
            v-if="opts.content"
            v-html="opts.content"
          ></div>
        </template>
  
        <!-- 图片内容 -->
        <div
          class="is-img"
          v-else-if="opts.type == 1"
          :style="`background-image: url('${opts.showImgUrl}');`"
        ></div>
        <!-- 按钮 -->
        <div class="footer" v-if="opts.buttonShowStatus == 1">
          <van-button type="default" class="btn1" @click="cancel('leftButton')">{{
            opts.leftButtonWord
          }}</van-button>
          <van-button type="primary" class="btn2" @click="confirm">{{
            opts.rightButtonWord
          }}</van-button>
        </div>
      </div>
    </template>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
      opts: {
        styleType: 0, //弹框提示样式：0固定样式，1图片样式
        buttonShowStatus: 0, // 按钮显示状态：0:不显示，1:显示
        content: '',
        jumpType: 1, // 跳转类型：0:外部网页，1:内部地址
        jumpUrl: '',
        leftButtonWord: '下次再去',
        rightButtonWord: '去看看',
        showImgUrl: '',
        showStatus: 0, // 开启状态：0:关闭，1:开启
        title: '',
        type: 0, // 通知类型：0:文字通知，1:图片通知
        productPackage: 1,
      },
    };
  },
  methods: {
    show(opts) {
      this.opened = true;
      Object.assign(this.opts, opts);
      return new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
      });
    },
    confirm(val) {
      this._resolve(this.opts);
      this.opened = false;
    },
    cancel(type) {
      this._reject(type);
      this.opened = false;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.system-update {
  width: calc(var(--gap) * 311);
  background-color: transparent;
  z-index: 2004 !important;
  &.fill {
    width: 100%;
    .update-img {
      width: 100%;
    }
    .popup-close {
      text-align: center;
      .van-icon {
        font-size: 36px;
      }
    }
  }
  .popup-top {
    padding-top: 59%;
    background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00121.png)
      center/cover no-repeat;
    // &.sports {
    //   background: transparent
    //     url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00119.png) center/cover
    //     no-repeat;
    // }
  }
  .popup-content {
    background-color: var(--white);
    border-bottom-left-radius: var(--radius-md);
    border-bottom-right-radius: var(--radius-md);
    &.mg {
      // padding-top: calc(var(--gap) * 12);
      margin-top: calc(var(--gap) * -15);
    }
    .is-txt {
      height: calc(var(--gap) * 200);
      overflow-y: auto;
      padding: 0 calc(var(--gap) * 24);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      white-space: pre-wrap;
    }
    .is-img {
      width: 100%;
      height: 103.47vw;
      background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0051.png);
      background-size: 100%;
      background-position: center;
    }
    .footer {
      padding: calc(var(--gap) * 12) calc(var(--gap) * 24) calc(var(--gap) * 20) calc(var(--gap) * 24);
      display: flex;
      .btn1 {
        flex: 1;
        color: var(--c1);
        border: 1px solid var(--c1);
        border-radius: calc(var(--gap) * 8);
      }
      .btn2 {
        flex: 1;
        margin-left: calc(var(--gap) * 11);
        border-radius: calc(var(--gap) * 8);
      }
    }
  }
}
</style>
